import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'app/services/models/company.service';
import { PdfService } from 'app/services/models/pdf.service';
import { TransactionDescriptionService } from 'app/services/models/transaction-description.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { ToastrService } from 'ngx-toastr';
import { Content, TDocumentDefinitions } from 'pdfmake/interfaces';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import QRCode from 'qrcode';
import htmlToPdfmake from 'html-to-pdfmake';
import { PdfFontService } from 'app/services/common/pdf-font.service';
import { EncryptionUrlService } from 'app/services/common/encryption-url.service';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
(pdfMake as any).fonts = {
  RobotoSerif: {
    normal: 'RobotoSerif-Regular.ttf', // Add the font path to the VFS here
    bold: 'RobotoSerif-Bold.ttf',      // Add the font path to the VFS here
    italics: 'RobotoSerif-Italic.ttf', // Add the font path to the VFS here
    bolditalics: 'RobotoSerif-BoldItalic.ttf', // Add the font path to the VFS here
  }
};

@Component({
  selector: 'app-send-print-transaction',
  templateUrl: './send-print-transaction.component.html',
  styleUrls: ['./send-print-transaction.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SendPrintTransactionComponent implements OnInit {
  @Input() data: { transactionId: number; whatsappMessage?: string };
  form: FormGroup;
  pdfs: any[] = []

  descriptions: any[] = [];

  pdf: any = {};
  transaction: any = {};
  company: any = {};

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private pdfService: PdfService,
    private transactionService: TransactionService,
    private companyService: CompanyService,
    private toastService: ToastrService,
    private transactionManagementDescription: TransactionDescriptionService,
    private pdfFontService: PdfFontService,
    private encryptionService: EncryptionUrlService
  ) { }

  async ngOnInit() {
    console.log(this.data);
    this.form = this.fb.group({
      pdfId: [null, Validators.required],
      whatsappMessage: [null],
    });
    if (this.data.whatsappMessage != null) {
      this.form.patchValue({
        whatsappMessage: this.data.whatsappMessage
      })
    }
    await this.getAllPdf();
    await this.getAllDescription();
    await this.getByIdTransaction(this.data.transactionId);
    await this.pdfFontService.loadFonts();

  }

  applyDefaultFontSize(obj: any, xlarge: number = 12, large: number = 10, normalFontSize: number = 8, smallFontSize: number = 6) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.applyDefaultFontSize(item, xlarge, large, normalFontSize, smallFontSize));
    } else if (typeof obj === "object" && obj !== null) {
      // If the object contains text and doesn't have fontSize defined
      if (obj.text && !obj.fontSize) {
        // Apply the normal font size by default
        obj.fontSize = normalFontSize;
      }

      // Adjust the font size if 'ql-size-small' is present in style
      if (obj.text && obj.style?.includes("ql-size-small")) {
        obj.fontSize = smallFontSize; // Apply small font size
      }

      if (obj.text && obj.style?.includes("ql-size-large")) {
        obj.fontSize = large;
      }

      if (obj.text && obj.style?.includes("ql-size-huge")) {
        obj.fontSize = xlarge;
      }
      // If the object has margin, reduce it by 10%
      if (obj.margin) {
        obj.margin = obj.margin.map((m: number) => m * 0.1);
      }

      // Recursively apply the function to nested properties
      Object.keys(obj).forEach(key => {
        obj[key] = this.applyDefaultFontSize(obj[key], xlarge, large, normalFontSize, smallFontSize);
      });
    }
    return obj;
  }

  async getAllDescription() {
    const data = await this.transactionManagementDescription.getAllTransactionDescriptions();
    this.descriptions = data;
    console.log(this.descriptions)
  }

  async getByIdTransaction(transactionId) {
    const data = await this.transactionService.getByIdTransaction(transactionId);
    console.log(data);
    this.transaction = data;
    await this.companyById(1)
    this.collectAllVariantNames();

  }

  async getAllPdf() {
    const data = await this.pdfService.getAllPdfsList(0, 100);
    this.pdfs = data.pdfs;
    console.log(this.pdfs);
    if (this.pdfs) {
      this.form.patchValue({
        pdfId: this.pdfs[0].id
      });
      console.log(this.form.value.pdfId)
      //  await this.getByIdPdf(this.form.value.pdfId);
    }
  }

  async getByIdPdf(id) {
    const data = await this.pdfService.getByIdPdf(id);
    console.log(data);
    this.pdf = data;
  }
  closeModal() {
    this.activeModal.close(false);
  }

  async submitForm(isOpened) {
    if (this.form.valid) {
      console.log(this.form.value);
      await this.getByIdPdf(this.form.value.pdfId);
      await this.generatePDF(isOpened);
    }
  }


  getFileTypeFromUrl(url: string): string | null {
    const fileExtensionPattern = /\.(png|jpg|jpeg)$/i; // Geçerli dosya uzantıları
    const match = url?.match(fileExtensionPattern);
    return match ? match[0]?.substring(1) : null; // Uzantıyı döndür (örneğin, "png", "jpg")
  }

  public getBase64ImageUrl(base64: string, fileUrl?: string): string {
    const type = this.getFileTypeFromUrl(fileUrl) ?? 'jpeg';
    console.log(type);
    return `data:image/${type};base64,${base64}`;
  }

  async companyById(id) {
    const data = await this.companyService.getByIdCompany(id);
    this.company = data;
    console.log(this.company);
  }

  formatDateTR(dateString: string | null | undefined): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ay 0-indexli
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  generatePdfBlob(): Promise<Blob> {
    return new Promise((resolve) => {
      const docDefinition = this.getDocDefinition(); // senin mevcut fonksiyon
      pdfMake.createPdf(docDefinition).getBlob((blob) => {
        resolve(blob);
      });
    });
  }

  async sendPdfToWhatsapp() {
    const blob = await this.generatePdfBlob();
    const blobUrl = URL.createObjectURL(blob);
    if (!this.transaction?.companyPhoneNumber || !this.transaction.companyPhoneNumber.trim()) {
      this.toastService.error('İlgili firmanın telefon numarası kayıtlı değil.');
      return; // Burada çıkıyoruz, aşağıdaki kodlar çalışmaz
    }
    const phoneNumber = `90${this.transaction?.companyPhoneNumber}`;
    const companyName = `${this.company?.companyName}`;
    const companyAppUserName = `${this.transaction?.appUserName} ${this.transaction?.appUserLastNaem}`;
    const message = `${this.data.whatsappMessage}\n\n${companyName}\n${companyAppUserName}`;
    const encodedMessage = encodeURIComponent(message);

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  }

  getDocDefinition(): any {
    return {
      defaultStyle: { font: 'RobotoSerif' },
      pageSize: { width: 595.28, height: 841.89 },
      pageMargins: [40, 160, 40, 45],
      header: {
        margin: [40, 10, 40, 10], // kesinlikle 4 elemanlı olmalı
        stack: [
          { text: 'Başlık', style: 'header' }
        ]
      },
      content: [
        { text: 'İçerik buraya gelecek', margin: [0, 5, 0, 15] } // yine 4 elemanlı margin
      ],
      footer: (currentPage: number, pageCount: number) => ({
        text: `Sayfa ${currentPage} / ${pageCount}`,
        alignment: 'center',
        margin: [0, 10, 0, 0]
      }),
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 10, 0]
        }
      }
    };
  }


  async generatePDF(isOpened) {
    await this.pdfFontService.loadFonts();
    await this.generateQRCode(this.transaction.companyId, this.transaction.no)
    const docDefinition: any = {
      defaultStyle: { font: 'RobotoSerif' },
      pageSize: {
        width: 595.28,
        height: 841.89
      },
      pageMargins: [40, 180, 40, 45],
      header: this.buildHeader(),
      content: this.buildContent(),
      footer: (currentPage: number, pageCount: number) => this.buildFooter(currentPage, pageCount),
      styles: this.buildStyles()
    };

    const companyName = this.transaction.companyName || '';
    const offerNo = this.transaction.no || '';

    // Şirket adından ilk iki kelimeyi al ve '-' ile birleştir
    const nameParts = companyName.trim().split(/\s+/);
    const formattedName = nameParts.slice(0, 2).join('-');

    // Dosya adını oluştur
    const fileName = `${offerNo}-${this.transaction.kindName}-${formattedName}.pdf`;
    if (isOpened == false) {
      pdfMake.createPdf(docDefinition).open();
    } else {
      pdfMake.createPdf(docDefinition).download(fileName);
    }
  }

  private buildHeader() {
    console.log(this.allVariantNames);

    return {
      margin: [35, 10, 35, 0],
      stack: [
        {
          table: {
            widths: ['25%', '50%', '25%'],
            body: [
              [
                this.headerLeft(),
                this.headerCenter(),
                this.headerRight()
              ]
            ]
          },
          layout: 'noBorders'
        },
        {
          canvas: [
            { type: 'line', x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1 }
          ],
          margin: [0, 0, 0, 0]
        }
      ]
    };
  }

  private headerLeft() {
    if (!this.company?.companyFile64) return { text: '' };
    return {
      width: 140,
      margin: [0, 30, 0, 0],
      image: `data:image/png;base64,${this.company.companyFile64}`,
      fit: [130, 130],  // daha küçük fit
      alignment: 'left'
    };
  }

  private headerCenter() {
    return {
      margin: [15, 45, 0, 0],
      stack: [
        { text: htmlToPdfmake(this.pdf.title) },
        { text: htmlToPdfmake(this.pdf.titleDescription), style: 'subHeaderCenter' },
        // { text: `Tel: ${this.company.phoneNumber ?? ""} Mail: ${this.company.mail ?? ""}`, style: 'subHeaderCenter' }
      ],
      alignment: 'center'
    };
  }

  private headerRight() {
    if (!this.pdf?.files?.length) return { text: '' };
    return {
      margin: [0, 5, 0, 0],
      image: `data:image/png;base64,${this.pdf.files[0].base64Image}`,
      fit: [120, 120],
      alignment: 'right'
    };
  }

  private buildContent() {
    const transactionDescription = this.transaction?.transactionManagementDescriptionConnects[0]?.description;
    let descriptionTransaction: any[] = [];
    if (transactionDescription) {
      descriptionTransaction = htmlToPdfmake(transactionDescription);
      this.applyDefaultFontSize(descriptionTransaction);
      console.log(descriptionTransaction);
    }

    //const currencyName = this.company.currencyName;
    const currencyName = null;

    const tableRows = this.transaction.transactionManagementProducts.map((p, i) => {
      const gross = p.productPrice * p.productCount;
      const discount = gross * (p.discountRate || 0) / 100;
      const netTotal = gross - discount;

      // Temel kolonlar
      const row: any[] = [
        { text: (i + 1).toString(), style: 'productTableText', alignment: 'center' },
        { text: `${p.productName}\n${p.connectedProducts?.map(sub => sub.name + "\t" + `(${sub.productCount} Ad.)` + "\t" + `${new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sub.salePrice)} ${sub.currencyName}\n`).join(' ')}\n${p.transactionProductDescriptions.map(d => d.description).join('\n')}`, style: 'productTableText' },
      ];

      // Dinamik varyant kolonları
      this.allVariantNames.forEach(variantName => {
        console.log(this.getVariantValue(p, variantName));
        row.push({
          text: this.getVariantValue(p, variantName),
          style: 'productTableText',
          alignment: 'center'
        });
      });

      // Son kolonlar
      row.push(
        { text: p.productCount.toString(), style: 'productTableText', alignment: 'center' },
        { text: `${p.discountRate?.toString() || '0'}%`, style: 'productTableText', alignment: 'center' },
        { text: `${new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(p.productPrice)} ${p.currency}`, style: 'productTableText', alignment: 'right' },
        { text: `${new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(netTotal)} ${p.currency}`, style: 'productTableText', alignment: 'right' }
      );

      return row;
    });

    const totalGross = this.sumGross();
    const totalDiscount = this.sumDiscount();
    const netTotal = this.sumNetTotal();
    const sumProductCount = this.sumCount();
    const sumVat = this.sumVat();
    const emptyCells = new Array(this.allVariantNames.length).fill({ text: '', border: [true, false, false, false] });

    const totalRows = [
      // Brüt Toplam Satırı
      [
        // İlk 4 temel sütun için boş hücreler
        { text: '', border: [true, false, false, false] },
        { text: '', border: [false, false, true, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },

        // Dinamik varyant kolonları için boş hücreler
        ...emptyCells,

        // Son iki kolon: B. Fiyat yerine Brüt Toplam, Toplam yerine değer
        { text: 'Brüt Toplam', style: 'productTableText', alignment: 'left' },
        { text: `${this.formatCurrency(totalGross, currencyName)}`, style: 'productTableText', alignment: 'right' }
      ],

      // İndirim Satırı
      [
        // İlk 4 temel sütun için boş hücreler
        { text: '', border: [true, false, false, false] },
        { text: '', border: [false, false, true, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },

        // Dinamik varyant kolonları için boş hücreler
        ...emptyCells,

        // Son iki kolon: B. Fiyat yerine İndirim, Toplam yerine değer
        { text: 'İndirim', style: 'productTableText', alignment: 'left', color: 'red' },
        { text: `${this.formatCurrency(totalDiscount, currencyName)}`, style: 'productTableText', alignment: 'right', color: 'red' }
      ],

      // Genel Toplam Satırı - Bu zaten doğru görünüyor, çünkü tüm başlangıç sütunlarını atlayıp
      // sadece 'Genel Toplam' ve değer kolonlarını gösteriyor.
      [
        // İlk 4 temel sütun için boş hücreler
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },

        // Dinamik varyant kolonları için boş hücreler
        ...emptyCells,

        // Son iki kolon: Genel Toplam ve değer
        { text: 'Genel Toplam', style: 'productTableText', alignment: 'left', bold: true, border: [false, false, false, true] },
        { text: `${this.formatCurrency(netTotal, currencyName)}`, style: 'productTableText', alignment: 'right', bold: true, border: [false, false, false, true] }
      ],

      // KDV Satırı - Bu satırda da başlangıçtaki boş hücreleri eklemelisiniz.
      [
        // İlk 4 temel sütun için boş hücreler
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },

        // Dinamik varyant kolonları için boş hücreler
        ...emptyCells,

        // Son iki kolon: KDV Bilgisi
        { text: '', border: [false, false, false, true] }, // Boş hücre
        { text: `KDV dahil değildir.`, noWrap: true, style: 'productTableText', alignment: 'right', bold: true, border: [false, false, false, true] }
      ]
    ];

    const chunks = this.chunkArray(tableRows, 29);

    const tables = chunks.map((chunk, idx) => {
      const isLastChunk = idx === chunks.length - 1;
      const chunkWithTotals = isLastChunk ? [...chunk, ...totalRows] : chunk;

      // Header satırını oluştur
      const headerRow = this.buildTableHeader();

      const baseHeaders = ['No', 'Açıklama'];
      const variantHeaders = this.allVariantNames; // örnek: ['Renk', 'Beden']
      const finalHeaders = ['Adet', 'İndirim', 'B. Fiyat', 'Toplam'];

      const allHeaders = [...baseHeaders, ...variantHeaders, ...finalHeaders];
      const totalColumnCount = allHeaders.length;
      const widths: (string | number)[] = []; const descriptionColumnIndex = 1;
      // Tabloyu oluştur
      for (let i = 0; i < totalColumnCount; i++) {
        if (i === descriptionColumnIndex) {
          // 'Açıklama' sütununa '*' değerini ata, kalan boşluğu doldurmasını sağla
          widths.push('*');
        } else {
          // Diğer tüm sütunlara 'auto' (içeriği kadar genişlemesini sağla)
          widths.push('auto');
        }
      }
      const table = {
        table: {
          headerRows: 1, // 🔹 Header olduğunu belirt
          widths: widths,
          body: [
            this.buildTableHeader(),     // 🔹 Header satırını ilk sıraya koy
            ...chunkWithTotals
          ]
        },
        layout: 'lightHorizontalLines',
        margin: [0, 10, 0, 10]
      };

      return table;
    });


    return [
      {
        text: 'TEKLİF', style: 'offerTitle'
      },
      this.infoTable(),

      {
        table: {
          widths: ['*'],
          body: [
            [
              {
                text: htmlToPdfmake(this.pdf.description) ?? '',
                fontSize: 8,
                alignment: 'justify',
                margin: [0, 0, 0, 10],
                width: '100%'
              }
            ]
          ]
        },
        layout: 'noBorders'
      },

      ...tables,

      { text: this.transaction.transactionPrivateNode ?? '', style: 'descriptionText' },

      transactionDescription ? { stack: descriptionTransaction, pageBreak: 'before', margin: [0, -20, 0, 0] } : { text: '' },

      {
        table: {
          headerRows: 1,
          widths: ['*', '*'],
          body: [
            [{ text: `${this.company.companyName}`, fontSize: 10, alignment: 'center' }, { text: 'Müşteri Onay', fontSize: 10, alignment: 'center' }], // header
            [
              {
                stack: [
                  { image: this.qrCodeBase64, fit: [65, 65], alignment: 'left' },
                  { text: 'Teklif Doğrulama', fontSize: 6, alignment: 'left', margin: [5, 0, 0, 0] }
                ]
              },
              { text: 'Kaşe / İmza:', fontSize: 8, alignment: 'center' }
            ],
          ]
        }
      }

    ];
  }

  qrCodeBase64: string;

  async generateQRCode(companyId, offerNo: string): Promise<void> {
    // URL'yi oluşturuyoruz
    const baseUrl = window.location.origin;
    console.log(baseUrl)
    const encodedCompanyId = this.encryptionService.encryptId(companyId.toString()); // companyId base64'e çevrilir
    console.log(encodedCompanyId);
    const url = `${baseUrl}/#/pages/offer-confirmed/${encodedCompanyId}/${offerNo}`;
    try {
      // QR kodunu Base64 formatında oluşturuyoruz
      this.qrCodeBase64 = await QRCode.toDataURL(url);  // Base64 formatında QR kodu al
      console.log(this.qrCodeBase64); // Konsola QR kodunun Base64 çıktısını yazdır
    } catch (err) {
      console.error('QR Kod oluşturulurken hata oluştu:', err);
    }
  }

  private buildFooter(currentPage: number, pageCount: number) {
    return {
      margin: [35, 0, 35, 0],
      stack: [
        { text: htmlToPdfmake(this.pdf?.footer), alignment: 'left', fontSize: 8 },
        {
          columns: [
            { text: 'F.32', fontSize: 9, alignment: 'left' },
            { text: `Sayfa ${currentPage} / ${pageCount}`, fontSize: 9, alignment: 'right' }
          ]
        }
      ]
    };
  }
  // --- Helper methods ---

  private buildTableHeader() {
    // Temel kolonlar
    const baseHeaders = [
      { text: 'No', style: 'productTableHeader', alignment: 'center' },
      { text: 'Açıklama', style: 'productTableHeader', alignment: 'center' },
    ];

    // Dinamik varyant kolonları
    const variantHeaders = this.allVariantNames.map(v => ({
      text: v,
      style: 'productTableHeader',
      alignment: 'center'
    }));

    // Son kolonlar
    const finalHeaders = [
      { text: 'Adet', style: 'productTableHeader', alignment: 'center' },
      { text: 'İndirim', style: 'productTableHeader', alignment: 'center' },
      { text: 'B. Fiyat', style: 'productTableHeader', alignment: 'center' },
      { text: 'Toplam', style: 'productTableHeader', alignment: 'center' }
    ];

    return [...baseHeaders, ...variantHeaders, ...finalHeaders];
  }

  private makeTable(body: any[], header: any[]) {
    return {
      table: {
        headerRows: 1, // Bu satırı ekleyin!
        widths: ['auto', '30%', 'auto', 'auto', '*', '*', '15%', '15%'],
        body: [header, ...body]
      },
      layout: 'lightHorizontalLines',
      margin: [0, 10, 0, 10]
    };
  }

  private chunkArray(arr: any[], size: number) {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  private formatCurrency(value: number, currencyName?: string): string {
    return `${new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)}`;
  }

  private formatPrice(value: number, unit: string) {
    const formatted = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    return `${formatted} ${unit}`;
  }

  private infoTable() {
    return {
      style: 'infoTable',
      stack: [
        //this.headerInfo(),
        {
          table: {
            widths: ['70%', '30%'],
            body: [
              [this.clientInfo(), this.docInfo()]
            ]
          },
          layout: 'noBorders',
        },
      ],
      margin: [0, 10, 0, 5]
    };
  }

  private headerInfo() {
    return {
      table: {
        widths: ['11%', '81%'], // 20 - 80 oranı
        body: [
          [
            { text: 'Firma', fontSize: 10, bold: true, alignment: 'left' },
            { text: this.transaction.companyName || '-', fontSize: 10, alignment: 'left' }
          ],
          [
            { text: 'Adres', fontSize: 10, bold: true, alignment: 'left' },
            { text: this.transaction.companyAddress || '-', fontSize: 10, alignment: 'left' }
          ]
        ]
      },
      layout: 'noBorders', // kenarlıkları kaldırır
      margin: [0, 0, 0, 0]
    };
  }


  private clientInfo() {
    return {
      table: {
        widths: ['auto', '*'],
        body: [
          [
            { text: 'Firma', fontSize: 10, bold: true, alignment: 'left' },
            { text: this.transaction.companyName || '-', fontSize: 10, alignment: 'left' }
          ],
          // 🔹 Adres
          [
            { text: 'Adres', fontSize: 10, bold: true, alignment: 'left' },
            { text: this.transaction.companyAddress || '-', fontSize: 10, alignment: 'left' }
          ],
          [
            {
              text: [
                { text: 'İlgili', fontSize: 10, bold: true, alignment: 'left' },
                // { text: ' / Contact Person', fontSize: 8, italics: true, color: 'gray' }
              ]
            },
            { text: `${this.transaction.personName || ''} ${this.transaction.personLastName || ''}`, fontSize: 10 }
          ],
          [
            {
              text: [
                { text: 'Tel', fontSize: 10, bold: true, alignment: 'left' },
                // { text: ' / Phone', fontSize: 8, color: 'gray', italics: true }
              ]
            },
            { text: this.transaction.companyPhoneNumber || '-', fontSize: 10 }
          ],
          [
            {
              text: [
                { text: 'Hazırlayan', fontSize: 10, bold: true, alignment: 'left' },
                // { text: ' / Prepared By', fontSize: 8, italics: true, color: 'gray' }
              ]
            },
            { text: `${this.transaction.appUserName || ''} ${this.transaction.appUserLastNaem || ''}`, fontSize: 10 }
          ]
        ]
      },
      layout: 'noBorders',
      margin: [0, 0, 0, 10]
    };
  }

  private docInfo() {
    return {
      table: {
        widths: ['53%', '47%'],
        body: [
          [
            {
              text: [
                { text: 'Tarih', fontSize: 10, bold: true, alignment: 'left' },
                //{ text: ' / Date', fontSize: 8, italics: true, color: 'gray' }
              ]
            },
            { text: this.formatDateTR(this.transaction.transactionCraetedAt), fontSize: 10, alignment: 'right' }
          ],
          [
            {
              text: [
                { text: 'Teklif No', fontSize: 10, bold: true, alignment: 'left' },
                //{ text: ' / Offer No', fontSize: 8, italics: true, color: 'gray' }
              ]
            },
            { text: this.transaction.no, fontSize: 10, alignment: 'right' }
          ],
          [
            {
              text: [
                { text: 'Vergi Dairesi', fontSize: 10, bold: true, alignment: 'left' },
                //{ text: ' / Tax Office', fontSize: 8, italics: true, color: 'gray' }
              ]
            },
            { text: this.transaction.taxAdministration || '-', fontSize: 10, alignment: 'right' }
          ],
          [
            {
              text: [
                { text: 'Vergi No', fontSize: 10, bold: true, alignment: 'left' },
                //{ text: ' / Tax Number', fontSize: 8, italics: true, color: 'gray' }
              ]
            },
            { text: this.transaction.taxNumber || '-', fontSize: 10, alignment: 'right' }
          ],
          [
            {
              text: [
                { text: 'Geçerlilik Tarihi', fontSize: 10, bold: true, alignment: 'left' },
                // { text: ' / Validity Date', fontSize: 8, italics: true, color: 'gray' }
              ]
            },
            { text: this.formatDateTR(this.transaction.validityDate), fontSize: 10, alignment: 'right' }
          ]
        ]
      },
      layout: 'noBorders',
      alignment: 'right'
    };
  }

  private buildStyles() {
    return {
      //headerCenter: { fontSize: 10, bold: true, alignment: 'center' },
      subHeaderCenter: { fontSize: 8, alignment: 'center' },
      offerTitle: { fontSize: 14, bold: true, alignment: 'center', decoration: 'underline', marginTop: -25 },
      descriptionText: { fontSize: 8 },
      tableHeader: { bold: true, fillColor: '#cccccc', fontSize: 8, alignment: 'center' },
      productTableText: { fontSize: 7, margin: [0, 0, 0, 0] },
      infoTable: { fontSize: 9, margin: [0, 0, 0, 5] },
      productTableHeader: { fontSize: 8, bold: true, fillColor: '#cccccc', alignment: 'center' }
    };
  }

  sumCount(): number {
    return this.transaction.transactionManagementProducts?.reduce((sum, product) => sum + product.productCount, 0) || 0;
  }

  sumGross(): number {
    return this.transaction.transactionManagementProducts?.reduce((sum, product) => {
      const total = product.productPrice * product.productCount;
      return sum + total;
    }, 0) || 0;
  }

  sumDiscount(): number {
    return this.transaction.transactionManagementProducts?.reduce((sum, product) => {
      const gross = product.productPrice * product.productCount;
      const discount = gross * (product.discountRate || 0) / 100;
      return sum + discount;
    }, 0) || 0;
  }

  sumVat(): number {
    return this.transaction.transactionManagementProducts?.reduce((sum, product) => {
      const gross = product.productPrice * product.productCount;
      const discount = gross * (product.discountRate || 0) / 100;
      const discountedTotal = gross - discount;
      const vat = discountedTotal * (product.taxRate || 0) / 100;
      return sum + vat;
    }, 0) || 0;
  }

  sumNetTotal(): number {
    const grossTotal = this.sumGross();
    const discountTotal = this.sumDiscount();
    return (grossTotal - discountTotal);
  }

  calculateTaxTotal(): any[] {
    const taxTotals = [];
    this.transaction.transactionManagementProducts?.forEach(product => {
      const taxAmount = (product.productPrice * product.taxRate / 100) * product.productCount;
      const existingTax = taxTotals.find(t => t.taxRate === product.taxRate);
      if (existingTax) {
        existingTax.totalTax += taxAmount;
      } else {
        taxTotals.push({ taxRate: product.taxRate, totalTax: taxAmount });
      }
    });
    return taxTotals;
  }

  calculateCurrencyTotal(): any[] {
    const currencyTotals = [];
    this.transaction.transactionManagementProducts?.forEach(product => {
      const totalAmount = product.productPrice * product.productCount;
      const existingCurrency = currencyTotals.find(c => c.currency === product.currency);
      if (existingCurrency) {
        existingCurrency.totalAmount += totalAmount;
      } else {
        currencyTotals.push({ currency: product.currency, totalAmount: totalAmount });
      }
    });
    return currencyTotals;
  }

  calculateGeneralTotal(): number {
    return this.sumNetTotal() + this.calculateTaxTotal().reduce((sum, item) => sum + item.totalTax, 0);
  }

  allVariantNames: any[] = [];

  collectAllVariantNames() {
    const variantSet = new Set<string>();

    this.transaction.transactionManagementProducts?.forEach(product => {
      product.transactionProductVariants?.forEach(v => {
        if (v.displayColonOrName === 2 && v.productVariantDefinitionName) {
          if (v.productVariantDefinitionSecondName != null)
            variantSet.add(v.productVariantDefinitionSecondName);
          else
            variantSet.add(v.productVariantDefinitionName);
        }
      });
    });

    this.allVariantNames = Array.from(variantSet);
  }

  // Hücre değeri alma fonksiyonu
  getVariantValue(product: any, variantName: string) {
    const variant = product.transactionProductVariants?.find(
      v => (v.productVariantDefinitionName === variantName || v.productVariantDefinitionSecondName === variantName) && (v.displayColonOrName === 2 || v.displayColonOrName === 3)
    );
    if (!variant) return '';

    switch (variant.variantType) {
      case 1: // seçmeli
        return variant.name ?? 'te';
      case 2: // boolean
        if (variant.valueBool === null || variant.valueBool === undefined) return '';
        return variant.valueBool ? variant.trueLabel : variant.falseLabel;
      case 3: // text
        return variant.valueText ?? '';
      default:
        return '';
    }
  }
}